import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Hexagon, Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const links = [
  { to: "/", label: "Home" },
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-bone/80 border-b border-forest/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <img
            src="/assets/brand/logo-badge.png"
            alt="ApiaryKeeper logo"
            className="w-9 h-9 rounded-lg transition-transform duration-300 group-hover:scale-105"
          />
          <span className="font-display text-xl md:text-2xl font-semibold tracking-tight text-forest">
            ApiaryKeeper
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="nav-links">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors duration-300 ${
                  isActive ? "text-honey-dark" : "text-forest/70 hover:text-forest"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/pre-register?src=nav"
            data-testid="nav-join-button"
            className="text-sm font-semibold bg-forest text-bone px-5 py-2.5 rounded-full transition-colors duration-300 hover:bg-honey hover:text-forest"
          >
            Join the Launch List
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-forest p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="md:hidden overflow-hidden border-t border-forest/10 bg-bone/95"
            data-testid="nav-mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                  className="font-display text-2xl text-forest"
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/pre-register?src=nav"
                onClick={() => setOpen(false)}
                data-testid="nav-mobile-join-button"
                className="mt-2 text-center text-sm font-semibold bg-forest text-bone px-5 py-3 rounded-full"
              >
                Join the Launch List
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
